var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7845_7654)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.853 1.14991C22.1732 0.471104 21.2517 0.0898438 20.291 0.0898438C19.3303 0.0898438 18.4089 0.471104 17.729 1.14991L1.46502 17.4139C0.999266 17.877 0.629977 18.4279 0.378513 19.0347C0.127049 19.6415 -0.00159798 20.2921 1.49812e-05 20.9489V23.0019C1.49812e-05 23.2671 0.105372 23.5215 0.292908 23.709C0.480445 23.8966 0.734799 24.0019 1.00002 24.0019H3.05301C3.70978 24.0038 4.36038 23.8753 4.96717 23.624C5.57396 23.3727 6.12487 23.0036 6.58801 22.5379L22.853 6.27291C23.5315 5.5931 23.9126 4.67187 23.9126 3.71141C23.9126 2.75094 23.5315 1.82971 22.853 1.14991ZM5.17401 21.1239C4.61002 21.6842 3.84798 21.9996 3.05301 22.0019H2.00002V20.9489C1.999 20.5548 2.07617 20.1644 2.22705 19.8004C2.37793 19.4363 2.59953 19.1058 2.87901 18.8279L15.222 6.48491L17.522 8.78491L5.17401 21.1239ZM21.438 4.85891L18.932 7.36591L16.632 5.07091L19.139 2.56391C19.29 2.41322 19.4693 2.29374 19.6664 2.21232C19.8636 2.13089 20.0749 2.0891 20.2883 2.08933C20.5016 2.08956 20.7128 2.13181 20.9098 2.21367C21.1069 2.29553 21.2858 2.41539 21.4365 2.56641C21.5872 2.71743 21.7067 2.89665 21.7881 3.09384C21.8695 3.29103 21.9113 3.50233 21.9111 3.71567C21.9109 3.92902 21.8686 4.14023 21.7868 4.33724C21.7049 4.53425 21.585 4.71321 21.434 4.86391L21.438 4.85891Z",
    fill: "#1B4458"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7845_7654"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdite);
export default __webpack_public_path__ + "static/media/edite.a0ca5981c8050468c35831b91669ec34.svg";
export { ForwardRef as ReactComponent };